import React from 'react';

const ComparisonTable: React.FC = () => {
  return (
    <section id="comparison" className="py-20 bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-white text-center mb-4">Complete Local Intelligence.</h2>
        <p className="text-center text-slate-400 mb-12">See why ProGeoData is the new standard for hyper-local marketing.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 rounded-2xl overflow-hidden border border-slate-700 bg-slate-800 shadow-2xl">
          
          {/* Competitor: Generic Lists */}
          <div className="p-8 border-b md:border-b-0 md:border-r border-slate-700 relative bg-slate-800/50">
            <div className="text-slate-500 font-bold uppercase tracking-wider mb-2 text-sm">Generic Business Lists</div>
            <div className="text-2xl font-bold text-slate-400 mb-6">The "Phonebook"</div>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start"><span className="text-emerald-500 mr-2 font-bold">✓</span> <span className="sr-only">Has feature:</span> Office Address: Yes.</li>
              <li className="flex items-start"><span className="text-rose-500 mr-2 font-bold">✕</span> <span className="sr-only">Missing feature:</span> License Status: No verification.</li>
              <li className="flex items-start"><span className="text-rose-500 mr-2 font-bold">✕</span> <span className="sr-only">Missing feature:</span> Updates: Monthly/Yearly.</li>
              <li className="flex items-start"><span className="text-rose-500 mr-2 font-bold">✕</span> <span className="sr-only">Missing feature:</span> Status: Often lists closed/retired pros.</li>
            </ul>
          </div>

          {/* US: ProGeoData */}
          <div className="p-8 bg-sky-900/10 relative z-10 border-b md:border-b-0 md:border-r border-slate-700 md:scale-105 md:rounded-lg md:shadow-xl border-t-4 border-t-sky-500">
            <div className="absolute top-0 right-0 bg-sky-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl">RECOMMENDED</div>
            <div className="text-sky-500 font-bold uppercase tracking-wider mb-2 text-sm">ProGeoData</div>
            <div className="text-2xl font-bold text-white mb-6">The "Source of Truth"</div>
            <ul className="space-y-4 text-sm text-white">
              <li className="flex items-start"><span className="text-emerald-400 mr-2 font-bold">✓</span> <strong>Office Address:</strong> Verified Geo-Location.</li>
              <li className="flex items-start"><span className="text-emerald-400 mr-2 font-bold">✓</span> <strong>License Status:</strong> Active vs Expired Filtering.</li>
              <li className="flex items-start"><span className="text-emerald-400 mr-2 font-bold">✓</span> <strong>Updates:</strong> Frequently Updated (24-48h).</li>
              <li className="flex items-start"><span className="text-amber-400 mr-2 font-bold">★</span> <strong>Real-Time Check:</strong> Optional API Upgrade.</li>
            </ul>
          </div>

          {/* Competitor: Enterprise DBs */}
          <div className="p-8 bg-slate-800/50">
            <div className="text-slate-500 font-bold uppercase tracking-wider mb-2 text-sm">Enterprise Databases</div>
            <div className="text-2xl font-bold text-slate-400 mb-6">The "Old Guard"</div>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start"><span className="text-emerald-500 mr-2 font-bold">✓</span> <span className="sr-only">Has feature:</span> Office Address: Yes.</li>
              <li className="flex items-start"><span className="text-amber-500 mr-2 font-bold">⚠</span> <span className="sr-only">Warning:</span> License Status: Often 6-12 months stale.</li>
              <li className="flex items-start"><span className="text-rose-500 mr-2 font-bold">✕</span> <span className="sr-only">Missing feature:</span> Contract: $15,000 annual minimums.</li>
              <li className="flex items-start"><span className="text-rose-500 mr-2 font-bold">✕</span> <span className="sr-only">Missing feature:</span> Local Nuance: Misses new agents.</li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
